module.exports = __webpack_public_path__ + "static/ocorie-abt-splash-img-1-7ed19fd16048390613e2a5fd38236779.png";